<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Adicionar Imagem
      </v-card-title>
      <v-card-text>
        <v-file-input
          ref="inputImageRef"
          v-model="selectedImage"
          filled
          accept="image/*"
          label="Imagem"
        />
        <v-select
          v-model="imageSize"
          :items="imageSizes"
          label="Tamanho de exibição"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          color="primary"
          @click="onSubmit"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import katex from 'katex'
export default {
  // components: {
  // },

  // props: {
  //   kInput: { type: String, default: null }
  // },

  data: () => ({
    selectedImage: null,
    imageSizes: [
      {
        text: 'Pequeno',
        value: 1
      }, {
        text: 'Médio',
        value: 2
      }, {
        text: 'Grande',
        value: 3
      }
    ],
    imageSize: 2
  }),

  // watch: {
  //   shouldShowImageUploadModal (value) {
  //     if (!value) {
  //       this.selectedImage = null
  //       this.imageSize = 2
  //     }
  //   }
  // },

  methods: {

    onSubmit () {
      const formData = new FormData()
      formData.append('image', this.selectedImage)
      const data = {
        image: formData,
        size: this.imageSize
      }
      this.$emit('resolve', data)
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
